<div class="container container-style-primary">
  <button class="rain-container" type="button" [disabled]="!canJoin()" (click)="chatService.openRainCaptcha()">
    <app-icon class="icon" icon="rain" [width]="20" />
    <div class="rain-button button" [ngClass]="{ red: !chatService.rain.joined, yellow: chatService.rain.joined }">
      <app-currency class="currency" [value]="chatService.rain.amount" [size]="14"></app-currency>
      <app-icon class="icon" icon="coin" />
    </div>
  </button>
  <button class="open-chat" (click)="uiService.toggleUIState('chat', 'open')">
    <app-icon class="icon" [width]="20" icon="collapse" />
    <span class="typography">Show chat</span>
  </button>
</div>
